(function () {
  const STORAGE_KEY = 'ragavi-recently-viewed';
  const MAX_ITEMS = 12;

  const readHistory = () => {
    try {
      const items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  };

  const writeHistory = (items) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
    } catch (error) {
      /* ignore quota / private mode */
    }
  };

  const saveCurrent = () => {
    const node = document.getElementById('RecentlyViewedCurrent');
    if (!node) return null;
    let product;
    try {
      product = JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
    if (!product || !product.handle) return product;
    const rest = readHistory().filter((item) => item.handle !== product.handle);
    writeHistory([product, ...rest]);
    return product;
  };

  const escapeHtml = (value) =>
    String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const cardHtml = (item) => {
    const onSale = Boolean(item.compare);
    return `<li class="recently-viewed__item">
      <a class="recently-viewed__card" href="${escapeHtml(item.url)}">
        <div class="recently-viewed__media">
          ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" width="360" height="360" loading="lazy">` : ''}
        </div>
        <p class="recently-viewed__title">${escapeHtml(item.title)}</p>
        <div class="recently-viewed__price${onSale ? ' is-sale' : ''}">
          <span class="recently-viewed__price-current">${escapeHtml(item.price)}</span>
          ${onSale ? `<s class="recently-viewed__price-compare">${escapeHtml(item.compare)}</s>` : ''}
        </div>
      </a>
    </li>`;
  };

  const renderSection = (current) => {
    const root = document.querySelector('[data-recently-viewed]');
    if (!root) return;
    const track = root.querySelector('[data-recently-viewed-track]');
    if (!track) return;
    const limit = Number(root.dataset.limit) || 8;
    const currentHandle = current && current.handle;
    const items = readHistory()
      .filter((item) => item.handle && item.handle !== currentHandle && item.url)
      .slice(0, limit);
    if (!items.length) {
      root.hidden = true;
      return;
    }
    track.innerHTML = items.map(cardHtml).join('');
    root.hidden = false;
  };

  const init = () => {
    const current = saveCurrent();
    renderSection(current);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
